import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from '../../shared/services/application.service';
import { AlertService } from '../../shared/services/alert.service';
import { take } from 'rxjs/operators';
import {
  extractTelebirrNotifyFields,
  isTelebirrCallbackSuccess
} from '../../shared/helpers/telebirr-return.util';

@Component({
    selector: 'welcome',
    templateUrl: 'welcome.component.html',
    styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  private static readonly applicationsListUrl = '/applications/all';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private applicationService: ApplicationService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const notifyFields = extractTelebirrNotifyFields(params);
      if (!notifyFields) {
        return;
      }
      const billRef = notifyFields['merch_order_id'];

      this.applicationService.telebirrPaymentReturn(notifyFields).subscribe(
        result => this.handleTelebirrReturn(billRef, result),
        () => {
          this.alertService.error(
            'Could not confirm Telebirr payment with the server. Please refresh your application or try again.'
          );
        }
      );
    });
  }

  private handleTelebirrReturn(
    billRef: string,
    result: { code?: string; msg?: string; applicationId?: number; ApplicationId?: number } | null
  ) {
    if (this.shouldRedirectAfterPayment(result)) {
      this.router.navigateByUrl(WelcomeComponent.applicationsListUrl);
      return;
    }

    if (result && result.code === '0' && result.msg === 'ignored') {
      this.applicationService.getApplicationIdByTelebirrBill(billRef).subscribe(
        lookup => {
          if (lookup?.applicationId || lookup?.ApplicationId) {
            this.router.navigateByUrl(WelcomeComponent.applicationsListUrl);
          }
        }
      );
      return;
    }

    this.alertService.warn(
      'Telebirr reported payment success but the application could not be updated automatically. ' +
      'Please open your applications list or contact support with bill reference ' + billRef + '.'
    );
  }

  private shouldRedirectAfterPayment(
    result: { code?: string; msg?: string; applicationId?: number; ApplicationId?: number } | null
  ): boolean {
    return isTelebirrCallbackSuccess(result);
  }
}
